export default __webpack_public_path__ + "static/media/social-twitter-blue.c35ddd00.svg";